import React from 'react';
import { CONFIG } from '../config/variables';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-white/10 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <div className="mb-6">
            {CONFIG.LOGO_URL !== "TOBEUPDATED" ? (
              <img 
                src={CONFIG.LOGO_URL} 
                alt={`${CONFIG.BUSINESS_NAME} logo`}
                className="h-8 w-auto mx-auto"
              />
            ) : (
              <div className="text-white font-bold text-xl">
                {CONFIG.BUSINESS_NAME}
              </div>
            )}
          </div>
          
          <div className="space-y-2 text-white/60">
            <p>Premium landing pages for Australian trade businesses</p>
            <p>Built by {CONFIG.BRAND_OWNER}</p>
            <p>
              <a 
                href={`tel:${CONFIG.BRAND_PHONE}`}
                className="hover:text-white transition-colors duration-200"
              >
                {CONFIG.BRAND_PHONE}
              </a>
            </p>
          </div>

          <div className="mt-8 pt-8 border-t border-white/10 text-white/40 text-sm">
            <p>&copy; 2024 {CONFIG.BRAND_OWNER}. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;